import React, { useEffect } from "react";

import ServiceDetail from "../components/ServiceDetail.jsx";
import Testimonials from "../components/Testimonials.jsx";
import AOS from "aos";
// import "aos/dist/aos.css"; // Ensure AOS styles are imported
import { Helmet } from "react-helmet";

const ServiceDetailPage = () => {
    useEffect(() => {
        if (typeof window !== "undefined") {
            AOS.init({
                duration: 1200, // Animation duration
            });
            window.scrollTo(0, 0); // Scroll to the top of the page
        }
    }, []);

    return (
        <>
            
            <ServiceDetail />
            <Testimonials />
        </>
    );
};

export default ServiceDetailPage;
